import { ServiceFetch } from '../service-fetch'

export default class OnesignalModel extends ServiceFetch {
    insertOnesignalPlayer = (data) => this.authFetch({
        url: 'onesignal/insertOnesignalPlayer',
        method: 'POST',
        body: JSON.stringify(data),
    })
}